import dataTables from "appdevresources/datatables";
import common from "appdevresources/common";
import Routing from "appdevresources/router";

$.widget("custom.ajaxAutocomplete", $.ui.autocomplete, {
    options: {
        autofocus: true,
        item: {
            identifier: item => item.pidm,
            label: item => `${item.lastName}, ${item.preferredName || item.firstName} (${item.bannerId}) ${item.username || ''}`,
            search: item => `${item.lastName} ${item.preferredName || item.firstName} ${item.bannerId} ${item.username || ''}`,
            selectedLabel: item => `${item.lastName}, ${item.preferredName || item.firstName} (${item.bannerId}) ${item.username || ''}`
        },
        clearSelectedIdOnLoad: true,
        keepSearchTerm: false,
        minLength: 4,
        searchClass: ".person-search",                  // This is the input element that will trigger the autocomplete
        selectedIdentifierClass: ".selected-pidm",      // This is the element where the unique id will be stored when a result is selected
        selectedSearchElement: ".selected-search-name", // This is the element that will display the selected result; can be same as searchClass
        selectedUserNameClass: ".selected-username",    // When present, this element holds the username of the selected result.
        valueParentElement: null,
        showExpandedResults: false,
        studentProfileRoute: "web_student_profile",
        additionalStudentProfileRouteParameters: {},
        submitOnSelect: false,
        url: null,
        source: function (request, response) {
            this.term = request.term;
            this._pageIndex = 1;
            this._loadedItems = [];
            this._loading = true;
            this._hasMore = false;

            response([{ value: "__loading__" }]);

            this._debouncedFetch(request.term, 1, false, response);
        },
        // disable callbacks we handle
        focus: () => false,
        select: () => false,
    },
    // pagination / ajax stuff
    _pageIndex: 0,
    _loadedItems: [],
    _loading: false,
    _hasMore: false,
    _cache: {},
    // state
    term: "",
    // ui
    _parentFormElement: null,
    _searchElement: null,
    _selectedUsernameElement: null,
    _selectedIdentifierElement: null,
    _selectedNameElement: null,
    _renderItem: function( ul, item ) {
        if (item.value === "__loading__") {
            return $("<li>")
                .append(`<div class="text-center">Loading...</div>`)
                .appendTo(ul);
        }
        if (item.value === "__expanded_results__") {
            return $("<li>")
                .append(`<div class="search-results-expand"><i class="fas fa-search" aria-hidden="true"></i>Expand search results</div>`)
                .appendTo(ul);
        }
        if (item.value === "__no_results__") {
            return $("<li>")
                .append(`<div class="text-center">No results found</div>`)
                .appendTo(ul);
        }
        let programData = [];
        if ("programs" in item) {
            item.programs.forEach(function (program) {
                programData.push(program.programDesc)
            });
        }

        const searchItem = this.options.item.label(item);

        return $(`<li 
                        data-program="${programData.join("<br> ")}" 
                        data-name="${item.lastName}, ${item.firstName}"
                        data-username="${item.username}" 
                        data-bannerid="${item.bannerId}"
                        data-id="${this.options.item.identifier(item)}" 
                        data-pidm="${item.pidm}">`)
            .append(`<div>${searchItem}</div>`)
            .appendTo(ul);
    },
    _debounce: function(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    },
    _getCacheKey: function(term, page) {
        return `${term}|${page}`;
    },
    _loadPage: function(term, page, append = false, responseCallback = null) {
        const self = this;
        const key = `${term}|${page}`;

        if (this._cache[key]) {
            const cached = this._cache[key];

            if (append) {
                this._loadedItems = this._loadedItems.concat(cached.results);
            } else {
                this._loadedItems = cached.results;
            }

            this._hasMore = cached.more;
            this._renderResults(this._loadedItems, responseCallback, append);
            return;
        }

        this._loading = true;

        $.ajax({
            url: this.options.url,
            type: "GET",
            dataType: "json",
            data: {
                term: term,
                page: page,
                _csrf_token: this._parentFormElement.find("input[name=_csrf_token]").val(),
            },
            success: function(data) {
                const results = data.results || [];
                const more = data.pagination?.more || false;

                self._cache[key] = { results, more };

                if (append) {
                    self._loadedItems = self._loadedItems.concat(results);
                } else {
                    self._loadedItems = results;
                }

                self._hasMore = more;
                self._renderResults(self._loadedItems, responseCallback, append);
                self._loading = false;
            }
        });
    },
    _create: function () {
        // Find UI elements
        this._parentFormElement = this.element.closest("form");
        this._valueElementParent = this.options.valueParentElement !== null ? this.options.valueParentElement : this._parentFormElement;
        this._selectedUsernameElement = this._valueElementParent.find(`${this.options.selectedUserNameClass}:first`);
        this._selectedIdentifierElement = this.options.selectedIdentifierClass !== null ? this._valueElementParent.find(`${this.options.selectedIdentifierClass}:first`) : null;
        this._selectedNameElement = this._valueElementParent.find(`${this.options.selectedSearchElement}:first`);

        // Return if already initialized with SAC
        if (this.element.data("sac-initialized")) {
            return;
        }
        this.element.data("sac-initialized", true);

        // handle clearSelectedIdOnLoad
        if (this._selectedIdentifierElement !== null && this.options.clearSelectedIdOnLoad) {
            this._selectedIdentifierElement.val("");
        }

        this._debouncedFetch = this._debounce((term, page, append, callback) => {
            this._loadPage(term, page, append, callback);
        }, this.options.delay || 300);

        $.ui.autocomplete.prototype._create.call(this);

        this._on(this.element, {
            ajaxautocompleteopen: () => {
                this._adjustMenuPosition();
            },
        });

        this._on(this.menu.element, {
            scroll: () => {
                const el = this.menu.element.get(0);
                if (!this._loading && el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && this._hasMore) {
                    this._pageIndex++;
                    this._loadPage(this.term, this._pageIndex, true);
                }
            },
            menufocus: (event, ui) => {
                const item = ui.item.data("ui-autocomplete-item");
                // If keepSearchTerm=false and not a helper element, set value accordingly of input box
                if (!this.options.keepSearchTerm && !item.value.startsWith("__")) {
                    this._value(this.options.item.selectedLabel(item));
                }
                return false;
            },
            menuselect: (event, ui) => {
                const item = ui.item.data("ui-autocomplete-item");
                if (item.value === "__expanded_results__") {
                    common.loadSpinner();
                    event.preventDefault();
                    const resultsDt = $("#expanded-results-table").DataTable();
                    resultsDt.clear();

                    $("ul.ui-autocomplete li").each((idx, student) => {
                        let studentId = $(student).data("bannerid") || "";
                        let studentName = $(student).data("name") || "";
                        let studentPrograms = $(student).data("program") || "";
                        let studentPidm = $(student).data("pidm") || "";
                        let routeParams = $.extend({pidm: studentPidm}, this.options.additionalStudentProfileRouteParameters);
                        let studentNameCell = `<a href="${this.options.studentProfileRoute ? Routing.generate(this.options.studentProfileRoute, routeParams) : "#"}" data-toggle="tooltip" title="View Student">${studentName}</a>`;
                        resultsDt.row.add([studentId, studentNameCell, studentPrograms]);
                    });

                    resultsDt.row(0).remove().draw();
                    common.initializeToolTips();
                    common.unloadSpinner();

                    $("#expanded-search-results-modal").modal("show")
                } else {
                    const searchElementValue = this.options.item.selectedLabel(item);

                    if (typeof searchElementValue === "string" && searchElementValue.length > 0) {
                        this._value(searchElementValue);
                        this.element.attr("title", this.options.item.label(item));
                    }

                    if (this._selectedIdentifierElement !== null) {
                        this._selectedIdentifierElement.val(this.options.item.identifier(item)).trigger("change");
                    }

                    this._selectedUsernameElement.val(item.username).trigger("change");

                    this._selectedNameElement.val(this.options.item.selectedLabel(item));

                    if (this.options.submitOnSelect) {
                        common.loadSpinner();
                        this._parentFormElement.trigger("submit");
                    }

                    return false;
                }
            },
        });

        // Load the frame for expanded results
        if (this.options.showExpandedResults) {
            $.get({
                url: Routing.generate("search-autocomplete-expanded-results")
            })
                .done(async function (data) {
                    const expandedResultsTable = $("#expanded-results-table");
                    if (expandedResultsTable.length === 0) {
                        $("body").append(data).ready(async function () {
                            await dataTables.create(expandedResultsTable);
                        });
                    }
                })
                .fail(function () {
                    console.debug("There was an error getting the expanded search results modal.")
                });
        }

        // If we want to autofocus the input bar, focus the input bar.
        if (this.options.autofocus) {
            this.element.focus();
        }
    },
    search: function (value, event) {
        if (/^\d+$/.test(value) && value.length < this.options.minLength) {
            event.preventDefault();
            return;
        }

        this.term = value;
        this._pageIndex = 0;
        this._loadedItems = [];
        this._hasMore = false;
        this._loading = false;
        $.ui.autocomplete.prototype.search.call(this, value, event);
    },
    _renderResults: function(items, responseCallback, append) {
        const results = [];

        if (items.length > 0) {
            // Only prepend the special expand item on the initial page, not while scrolling
            results.push({ value: "__expanded_results__" });
        }

        results.push(...items);

        if (!results.length) {
            results.push({ value: "__no_results__" });
        } else if (this._hasMore) {
            results.push({ value: "__loading__" });
        }

        if (responseCallback) {
            responseCallback(results); // for initial load
        } else {
            this._suggest(results); // for infinite scroll append
        }

        this._adjustMenuPosition()
    },
    _adjustMenuPosition: function() {
        requestAnimationFrame(() => {
            this.menu.element.css({
                "white-space": "nowrap",
                "min-width": this.element.outerWidth(),
            });
            this.menu.element.position({
                my: "left top",
                at: "left bottom",
                collision: "flip",
                of: this.element,
            });
        });
    },
});
